import { useState } from "react";

const Footer = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  // const { tenantId } = useTenant();

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setFormData({ name: "", phone: "", email: "", message: "" });
  };

  const openPrivacyPolicy = () => {
    const url = `${window.location.origin}/privacy-policy`;
    window.open(url, "_blank");
  };

  const openTermsConditions = () => {
    const url = `${window.location.origin}/terms-and-conditions`;
    window.open(url, "_blank");
  };

  return (
    <footer className="bg-[#0A344A] px-0 text-white lg:px-10 xl:px-0">
      {/* Top Section */}
      <div className="container mx-auto grid grid-cols-1 gap-6 px-6 py-8 md:grid-cols-2 md:gap-16 md:px-0 md:py-12">
        {/* Left Section */}
        <div className="w-full font-nunito text-[30px] not-italic leading-[40px] text-[var(--White,#FFF)] md:w-60">
          <h2 className="mb-4 font-nunito text-2xl font-bold text-white md:mb-8 md:text-3xl">
            Finease
          </h2>
          <div className="flex gap-4">
            <div className="mb-8">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M12 2C15.87 2 19 5.13 19 9C19 14.25 12 22 12 22C12 22 5 14.25 5 9C5 5.13 8.13 2 12 2ZM7 9C7 11.85 9.92 16.21 12 18.88C14.12 16.19 17 11.88 17 9C17 6.24 14.76 4 12 4C9.24 4 7 6.24 7 9ZM12 11.5C10.6193 11.5 9.5 10.3807 9.5 9C9.5 7.61929 10.6193 6.5 12 6.5C13.3807 6.5 14.5 7.61929 14.5 9C14.5 10.3807 13.3807 11.5 12 11.5Z"
                  fill="#1DAB91"
                />
              </svg>
            </div>
            <p className="mb-4 font-nunito text-[16px] leading-relaxed text-[#EAEAEA]">
              36, Third floor, Palm spring complex, Ellisbridge,
              Ahmedabad-380006, Gujarat
            </p>
          </div>
          <div className="mb-5 flex items-center gap-4 text-[#D1E3EA]">
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM20 18H4V8L12 13L20 8V18Z"
                  fill="#1DAB91"
                />
              </svg>
            </span>
            <span className="font-nunito text-[16px] leading-relaxed text-[#EAEAEA]">
              fineaseresearchpvtltd@gmail.com
            </span>
          </div>
          <div className="mb-8 flex items-center gap-4 text-[#D1E3EA]">
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M6.54 5C6.6 5.89 6.75 6.76 6.99 7.59L5.79 8.79C5.38 7.59 5.12 6.32 5.03 5H6.54ZM16.4 17.02C17.25 17.26 18.12 17.41 19 17.47V18.96C17.68 18.87 16.41 18.61 15.2 18.21L16.4 17.02ZM7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.51C21 15.96 20.55 15.51 20 15.51C18.76 15.51 17.55 15.31 16.43 14.94C16.33 14.9 16.22 14.89 16.12 14.89C15.86 14.89 15.61 14.99 15.41 15.18L13.21 17.38C10.38 15.93 8.06 13.62 6.62 10.79L8.82 8.59C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3Z"
                  fill="#1DAB91"
                />
              </svg>
            </span>{" "}
            <span className="font-nunito text-[16px] leading-relaxed text-[#EAEAEA]">
              079-2666588
            </span>
          </div>

          {/* Social Icons */}
          <div className="mt-4 flex gap-3 md:gap-4">
            <a
              href="https://www.facebook.com/TheFinEase"
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-full bg-[rgba(141,198,63,0.30)] p-2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3V2z"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
            <a
              href="https://www.instagram.com/thefinease/"
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-full bg-[rgba(141,198,63,0.3)] p-2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
              >
                <rect
                  x="2"
                  y="2"
                  width="20"
                  height="20"
                  rx="5"
                  stroke="white"
                  strokeWidth="2"
                />
                <path
                  d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <line
                  x1="17.5"
                  y1="6.5"
                  x2="17.51"
                  y2="6.5"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </a>
            <a
              href="https://x.com/i/flow/login?redirect_after_login=%2FTheFinEase"
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-full bg-[rgba(141,198,63,0.3)] p-2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
            <a
              href="https://www.linkedin.com/authwall?trk=bf&trkInfo=AQFyNoTpHmjFrwAAAZq-_C0I72H25d2vlt6ZHsqs-HCOpdFsHiJLFftUgtFxJGv7SmEreddGf0Tbbp5LcEM0hNoMNs1gBApE4-meHnm-lW-QnkYFERigaimERqoYamZK--38kkE=&original_referer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Fthefinease%2F"
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-full bg-[rgba(141,198,63,0.3)] p-2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <rect
                  x="2"
                  y="9"
                  width="4"
                  height="12"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <circle cx="4" cy="4" r="2" stroke="white" strokeWidth="1.5" />
              </svg>
            </a>
          </div>
        </div>

        {/* Right Section (Quick Contact Form) */}
        <div>
          <h3 className="mb-4 font-nunito text-lg font-semibold text-[#fff]">
            Quick Contact
          </h3>
          <form onSubmit={handleSubmit} className="space-y-3">
            <input
              type="text"
              name="name"
              placeholder="Name"
              value={formData.name}
              onChange={handleChange}
              className="w-full rounded-md bg-[#23698E] px-4 py-2.5 font-nunito text-[16px] text-white placeholder-[#EAEAEA] focus:outline-none focus:ring-2 focus:ring-[#1DAB91]"
            />
            <input
              type="text"
              name="phone"
              placeholder="Phone No."
              value={formData.phone}
              onChange={handleChange}
              className="w-full rounded-md bg-[#23698E] px-4 py-2.5 font-nunito text-[16px] text-white placeholder-[#EAEAEA] focus:outline-none focus:ring-2 focus:ring-[#1DAB91]"
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              className="w-full rounded-md bg-[#23698E] px-4 py-2.5 font-nunito text-[16px] text-white placeholder-[#EAEAEA] focus:outline-none focus:ring-2 focus:ring-[#1DAB91]"
            />
            <textarea
              name="message"
              placeholder="Message"
              value={formData.message}
              onChange={handleChange}
              className="h-20 w-full rounded-md bg-[#23698E] px-4 py-2.5 font-nunito text-[16px] text-white placeholder-[#EAEAEA] focus:outline-none focus:ring-2 focus:ring-[#1DAB91]"
            />
            <button
              type="submit"
              className="rounded-[6px] bg-[#1DAB91] px-5 py-2 font-nunito text-lg font-bold text-white transition hover:bg-[#179C84]"
            >
              Submit
            </button>
          </form>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-[#057170] px-4 md:px-0">
        <div className="container mx-auto flex flex-col items-center justify-between gap-3 py-4 text-center font-nunito text-[16px] font-bold text-[#EAEAEA] sm:flex-row sm:gap-6">
          <div className="flex items-center gap-2 md:gap-4">
            <button
              onClick={openPrivacyPolicy}
              className="cursor-pointer font-nunito text-[16px] font-bold text-[#EAEAEA] hover:underline"
            >
              Privacy Policy
            </button>

            <span className="sm:block">|</span>

            <button
              onClick={openTermsConditions}
              className="cursor-pointer font-nunito text-[16px] font-bold text-[#EAEAEA] hover:underline"
            >
              Terms & Conditions
            </button>
          </div>

          <div>
            <span className="font-nunito text-[16px] font-bold">
              Copyright © 2024 FinEase
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
